import { useEffect, useState } from 'react';
import { api } from '../../shared/api/client';
import type { VisitorStage } from '../../shared/api/types';

export const STAGES: [VisitorStage, string][] = [
  ['primera_visita', 'Primera visita'],
  ['contactado', 'Contactado'],
  ['segunda_visita', 'Segunda visita'],
  ['integrandose', 'Integrándose'],
  ['raices', 'En Raíces'],
  ['grupo', 'En un grupo'],
  ['miembro', 'Miembro'],
  ['no_continua', 'No continúa'],
];
export const stageLabel = (s: VisitorStage) => STAGES.find(([k]) => k === s)?.[1] ?? s;

export const INTERESTS = ['Conocer la iglesia', 'Estudio bíblico (Raíces)', 'Jóvenes', 'Damas', 'Varones', 'Niños', 'Oración', 'Servir'];

/** Solo dígitos para WhatsApp; si es de 10 dígitos, se asume México (+52). */
export const whatsappNumber = (phone: string) => {
  const d = phone.replace(/\D/g, '');
  return d.length === 10 ? `52${d}` : d;
};

const cache = new Map<string, Promise<{ canUse: boolean; slug: string | null }>>();
/** ¿La persona atiende visitantes (Diaconado o administración)? Se consulta una vez por iglesia. */
export function useVisitorAccess(churchId: string | null): { canUse: boolean; slug: string | null } {
  const [state, setState] = useState<{ canUse: boolean; slug: string | null }>({ canUse: false, slug: null });
  useEffect(() => {
    if (!churchId) return;
    let alive = true;
    if (!cache.has(churchId)) {
      cache.set(
        churchId,
        api.get<{ canUse: boolean; slug: string | null }>(`/multichurch/churches/${churchId}/visitors/access`).catch(() => {
          cache.delete(churchId);
          return { canUse: false, slug: null };
        }),
      );
    }
    void cache.get(churchId)!.then((r) => alive && setState(r));
    return () => {
      alive = false;
    };
  }, [churchId]);
  return state;
}

/** Para pruebas: olvida lo consultado. */
export const resetVisitorAccess = () => cache.clear();
